// Textos de la zona "auth". Claves con prefijo "auth." (common: sin prefijo fijo).
// Pantallas de entrada (Login, Registro, recuperar contraseña, confirmar correo)
// y el Dashboard.
const en = {
  // Campos compartidos
  'auth.field.email': 'Email',
  'auth.field.password': 'Password',
  'auth.field.name': 'Name',
  'auth.password.tooShort': 'Password must be at least {min} characters',
  'auth.password.hint': 'At least {min} characters. Use one you don’t reuse on other sites.',
  'auth.backToLogin': 'Back to sign in',

  // Login
  'auth.login.errorFallback': 'Incorrect credentials',
  'auth.login.submitting': 'Signing in…',
  'auth.login.submit': 'Sign in',
  'auth.login.forgot': 'Forgot your password?',
  'auth.login.noAccount': 'Don’t have an account?',
  'auth.login.register': 'Sign up',

  // Registro
  'auth.register.done': 'Done. If the email was new, your account is ready: sign in with your password. If you already had an account, we sent you an email explaining it.',
  'auth.register.errorFallback': 'Could not create the account. Please try again.',
  'auth.register.submitting': 'Creating account…',
  'auth.register.submit': 'Sign up',
  'auth.register.haveAccount': 'Already have an account?',
  'auth.register.login': 'Sign in',

  // Olvidé la contraseña
  'auth.forgot.errorFallback': 'Could not send the email. Please try again.',
  'auth.forgot.linkHint': 'The link in the email expires in 30 minutes and can only be used once. If you don’t see it, check your spam or junk folder.',
  'auth.forgot.title': 'Forgot your password?',
  'auth.forgot.intro': 'Enter your email and we’ll send you a link to create a new one.',
  'auth.forgot.sending': 'Sending…',
  'auth.forgot.submit': 'Send me the link',

  // Restablecer contraseña
  'auth.reset.mismatch': 'The two passwords don’t match',
  'auth.reset.done': 'Password changed. You can now sign in with the new one.',
  'auth.reset.errorFallback': 'Could not change the password. Request a new link.',
  'auth.reset.checking': 'Checking the link…',
  'auth.reset.invalid': 'This link no longer works: it expired or was already used.',
  'auth.reset.invalidHint': 'No problem — requesting another is instant and your account is untouched.',
  'auth.reset.requestNew': 'Request a new link',
  'auth.reset.title': 'Create your new password',
  'auth.reset.newPassword': 'New password',
  'auth.reset.repeat': 'Repeat the password',
  'auth.reset.saving': 'Saving…',
  'auth.reset.submit': 'Save and sign in',

  // Confirmar correo
  'auth.confirm.missingToken': 'The link is missing its code. Open it exactly as it arrived in your email.',
  'auth.confirm.errorFallback': 'Could not confirm the email. Request the change again.',
  'auth.confirm.confirming': 'Confirming your new email…',
  'auth.confirm.backToApp': 'Back to DragonAudio',
  'auth.confirm.goLogin': 'Go to sign in',

  // Dashboard
  'auth.dashboard.hello': 'Hi, {name}',
  'auth.dashboard.audioTest': 'Audio Test',
  'auth.dashboard.musicPlayer': 'Music Player',
};

const es = {
  'auth.field.email': 'Email',
  'auth.field.password': 'Contraseña',
  'auth.field.name': 'Nombre',
  'auth.password.tooShort': 'La contraseña debe tener al menos {min} caracteres',
  'auth.password.hint': 'Mínimo {min} caracteres. Usa una que no repitas en otras páginas.',
  'auth.backToLogin': 'Volver a iniciar sesión',

  'auth.login.errorFallback': 'Credenciales incorrectas',
  'auth.login.submitting': 'Entrando…',
  'auth.login.submit': 'Entrar',
  'auth.login.forgot': '¿Olvidaste tu contraseña?',
  'auth.login.noAccount': '¿No tienes cuenta?',
  'auth.login.register': 'Regístrate',

  'auth.register.done': 'Listo. Si el correo era nuevo, tu cuenta ya está creada: entra con tu contraseña. Si ya tenías cuenta, te enviamos un correo explicándolo.',
  'auth.register.errorFallback': 'No se pudo crear la cuenta. Vuelve a intentarlo.',
  'auth.register.submitting': 'Creando cuenta…',
  'auth.register.submit': 'Registrarse',
  'auth.register.haveAccount': '¿Ya tienes cuenta?',
  'auth.register.login': 'Inicia Sesión',

  'auth.forgot.errorFallback': 'No se pudo enviar el correo. Vuelve a intentarlo.',
  'auth.forgot.linkHint': 'El enlace del correo caduca en 30 minutos y solo se puede usar una vez. Si no lo ves, mira en la carpeta de spam o correo no deseado.',
  'auth.forgot.title': '¿Olvidaste tu contraseña?',
  'auth.forgot.intro': 'Escribe tu correo y te enviamos un enlace para crear una nueva.',
  'auth.forgot.sending': 'Enviando…',
  'auth.forgot.submit': 'Enviarme el enlace',

  'auth.reset.mismatch': 'Las dos contraseñas no coinciden',
  'auth.reset.done': 'Contraseña cambiada. Ya puedes entrar con la nueva.',
  'auth.reset.errorFallback': 'No se pudo cambiar la contraseña. Pide un enlace nuevo.',
  'auth.reset.checking': 'Comprobando el enlace…',
  'auth.reset.invalid': 'Este enlace ya no sirve: caducó o ya se usó una vez.',
  'auth.reset.invalidHint': 'No pasa nada, pedir otro es inmediato y tu cuenta sigue intacta.',
  'auth.reset.requestNew': 'Pedir un enlace nuevo',
  'auth.reset.title': 'Crea tu contraseña nueva',
  'auth.reset.newPassword': 'Contraseña nueva',
  'auth.reset.repeat': 'Repite la contraseña',
  'auth.reset.saving': 'Guardando…',
  'auth.reset.submit': 'Guardar y entrar',

  'auth.confirm.missingToken': 'Al enlace le falta el código. Ábrelo tal cual llegó al correo.',
  'auth.confirm.errorFallback': 'No se pudo confirmar el correo. Pide el cambio otra vez.',
  'auth.confirm.confirming': 'Confirmando tu correo nuevo…',
  'auth.confirm.backToApp': 'Volver a DragonAudio',
  'auth.confirm.goLogin': 'Ir a iniciar sesión',

  'auth.dashboard.hello': 'Hola, {name}',
  'auth.dashboard.audioTest': 'Prueba de Audio',
  'auth.dashboard.musicPlayer': 'Reproductor de Música',
};

const auth = { en, es };
export default auth;
